export const environment = {
  production: true,
  baseUrl: `https://regstation-qa-api.thetitlegirl.com`,
  apiBaseUrl: `https://core-api-qa.thetitlegirl.com`,
  registrationStationUrl: `https://regspace-qa.thetitlegirl.com`,
  integrationUrl: `https://mapping-api-qa.thetitlegirl.com`
};
